import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import apiKnowledgeBase from "../api";

// Advanced filter fields for the knowledge base list. Roles, trades and
// business types are many-to-many on tbl_knowledge_base; the get-all API maps
// these keys to them, and reads the other columns from the schema.
export const knowledgeBaseFilterFields = [
  { key: "user_role_fids", label: "Visible To Roles", type: "select", group: "Audience", optionsKey: "userRoles", optionLabel: "role" },
  { key: "trade_of_work_fids", label: "Trade of Work", type: "select", group: "Audience", optionsKey: "trades", optionLabel: "trade_name" },
  { key: "business_type_fids", label: "Business Type", type: "select", group: "Audience", optionsKey: "businessTypes", optionLabel: "name" },
  { ...STATUS_FIELD, group: "Details" },
  { key: "order", label: "Order", type: "int", group: "Details" },
  { key: "updated_date", label: "Last Updated", type: "datetime", group: "Dates" },
  { key: "created_date", label: "Created Date", type: "datetime", group: "Dates" },
];

// Dropdown data for the filter, fetched once when the drawer first opens.
export const loadKnowledgeBaseFilterDependencies = async () => {
  const [userRolesRes, tradesRes, businessTypesRes] = await Promise.allSettled([
    apiKnowledgeBase.getUserRolesForDropdown(),
    apiKnowledgeBase.getTradeOfWorksForDropdown(),
    apiKnowledgeBase.getBusinessTypesForDropdown(),
  ]);

  const extract = (res) => (res.status === "fulfilled" ? res.value?.data?.data || [] : []);

  return {
    userRoles: extract(userRolesRes),
    trades: extract(tradesRes),
    businessTypes: extract(businessTypesRes),
  };
};
